module.exports = __webpack_public_path__ + "media/images/top/qa/qa_show_banner02-f791c9947711cacbe3a62c8d3d6899b4.png";